import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { ActiveManagementFiltersValues } from '@/utils/constants'

export const mapActiveManagementFiltersToParams = (
    filters: ActiveManagementFiltersValues
) => {
    const timelineValue = parseTimelineFilter(filters.timeline)

    const baseParams = {
        nodeIds: filters.node.length ? filters.node : [],
        usnAccountIds: filters.usn?.length ? filters.usn : undefined,
        facilityIds: filters.facility.length ? filters.facility : undefined,
        tagIds: filters.tag.length ? filters.tag : undefined,
        meterIds: filters.meter.length ? filters.meter : undefined,
        subMeterIds: filters.subMeter?.length ? filters.subMeter : undefined,
    }

    if (filters.timeline.type === 'is') {
        return { ...baseParams, timeline: filters.timeline.value }
    }
    return {
        ...baseParams,
        startDate: timelineValue.startDate,
        endDate: timelineValue.endDate,
    }
}
